// @flow
import * as React from "react";

import { THEME_STORAGE_KEY } from "constants/theme";

import ThemeContext from "contexts/ThemeContext";

import { applyThemeMode, getInitialThemeMode } from "utils/theme";

import type { ThemeMode } from "types/theme";

type ThemeProviderProps = {
  children: React.Node,
};

function ThemeProvider({ children }: ThemeProviderProps): React.Node {
  const [theme, setThemeState] = React.useState<ThemeMode>(() => getInitialThemeMode());

  React.useEffect(() => {
    applyThemeMode(theme);
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  }, [theme]);

  const setTheme = React.useCallback((nextTheme: ThemeMode): void => {
    setThemeState(nextTheme);
  }, []);

  const toggleTheme = React.useCallback((): void => {
    setThemeState((currentTheme) => (currentTheme === "light" ? "dark" : "light"));
  }, []);

  return <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>{children}</ThemeContext.Provider>;
}

export default ThemeProvider;
